import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { Entity } from "src/app/core/models/entity.model";
import { User } from "src/app/core/models/user.model";
import { ConfigService } from "src/app/core/services/config.service";
import { EntityService } from "src/app/core/services/entity.service";
import { UserService } from "src/app/core/services/user.service";


@Injectable({
  providedIn: 'root'
})

export class DdbbUtils {

  constructor(
    private configSvc: ConfigService,
    private entityService: EntityService,
    private tranlat: EntityService
  ) { }

  getEntityChilds(_entityId: number, _page: number, _perPage: number): Promise<{ total: number, data: Entity[] }> {
    return new Promise((resolve, reject) => {
      this.entityService.index({ page: _page, perPage: _perPage, includeBase: true }).subscribe(response => {
        if (!this.configSvc.currentConfigValue.userEntity) this.configSvc.setConfigParamsValue('userEntity', response.data?.find((entity: Entity) => entity.id === _entityId));
        console.log('this.configSvc.currentConfigValue.userEntity', this.configSvc.currentConfigValue.userEntity);
        const childs = response.data;
        const childWithoutSame = response.data.filter((entity: Entity) => entity.id !== _entityId);
        console.log('childWithoutSame.length', childWithoutSame.length);
        resolve({ total: response.total, data: response.data.filter((entity: Entity) => entity.id !== _entityId) })
      });
    })
  }

  getEntityFamily(_entityId: number, _page: number, _perPage: number): Promise<{ total: number, data: Entity[] }> {
    return new Promise((resolve, reject) => {
      this.entityService.index({ page: _page, perPage: _perPage, includeBase: true }).subscribe(
        response => {
          const childs = response.data;
          console.log(response.data);
          const childWithoutSame = response.data.filter((entity: Entity) => entity.id !== _entityId);
          console.log(childWithoutSame.length);
          resolve({ total: response.total, data: response.data })
        }
      );
    })
  }

  forceModal = (_id: string, _dismiss: boolean) => {
    let openProgress = document.querySelector('#openProgress') as HTMLDivElement;
    if (!openProgress) (
      openProgress = document.createElement('div'),
      openProgress.id = 'openProgress',
      document.body.appendChild(openProgress),
      openProgress.setAttribute('data-bs-target', _id)
    );
    if (!_dismiss) {
      openProgress.setAttribute('data-bs-toggle', 'modal');
      openProgress.click();
      document.body.removeChild(openProgress);
    } else {
      setTimeout(() => {
        //to ensure right render while refreshing many times
        openProgress.setAttribute('data-bs-dismiss', 'modal');
        console.log(openProgress.parentNode);
        openProgress.click();
        document.body.removeChild(openProgress);
        console.log(document.querySelectorAll('#openProgress').length);
      }, 500); // .5 segundos
    }

  }

}

export const forceModal = (_id: string, _dismiss: boolean) => {
    let openProgress = document.querySelector('#openModalPb') as HTMLDivElement;
    if (!openProgress) (
      openProgress = document.createElement('div'),
      openProgress.id = 'openModalPb',
      document.body.appendChild(openProgress),
      openProgress.setAttribute('data-bs-target', _id)
    );
    if (!_dismiss) {
      openProgress.setAttribute('data-bs-toggle', 'modal');
      openProgress.click();
      document.body.removeChild(openProgress);
    } else {
      setTimeout(() => {
        //to ensure right render while refreshing many times
        openProgress.setAttribute('data-bs-dismiss', 'modal');
        console.log(openProgress.parentNode);
        openProgress.click();
        document.body.removeChild(openProgress);
        console.log(document.querySelectorAll('#openModalPb').length);
      }, 500); // .5 segundos
    }

  }


export const getBrowserLan = (): string => {
  return navigator.language || navigator.language
}

export function localStorageSetItem(name: string, item: unknown) {
  localStorage.setItem(name, JSON.stringify(item));
  window.dispatchEvent(new Event('storage'))
}

export function localStorageGetItem(name: string) {
  return localStorage.getItem(name) ? JSON.parse(localStorage.getItem(name) ?? '') : ''
}

export const ENTITY_TYPE_DISTRIBUTOR = 2;
export const ENTITY_TYPE_HEAD_OFFICE = 3;
export const ENTITY_TYPE_OPTICAL = 4;

// Roles mirror the entity type ids: an account's role does not have to match the
// access level it operates at, so both axes have to be checked separately.
export const ROLE_ADMIN = 1;
export const ROLE_DISTRIBUTOR = 2;
export const ROLE_HEAD_OFFICE = 3;

export const PROFILE_EDITOR = 1;
export const PROFILE_VIEWER = 2;
export const PROFILE_OWNER = 3;

export const DASHBOARD_CARD_DEFAULT_OUTLINE_COLOR = '#a0f9ba';
export const DASHBOARD_CARD_DEFAULT_HEADER_COLOR = '#194439';

export function localStorageRemoveItem(name: string) {
  localStorage.removeItem(name);
  window.dispatchEvent(new Event('storage'))
}

export function getProperty(obj: unknown, prop: string) {
  type objType = keyof typeof obj;
  return obj && Object.prototype.hasOwnProperty.call(obj, prop) ? obj[prop as objType] : null;
}

export function cleanParams(originalParams: any, emptyParams?: string[]) {
  const cleanProps: any = {};
  // Recorrer las propiedades del objeto original para copiarlas al nuevo objeto
  for (const key in originalParams) {
    // Solo copiar la propiedad si tiene valor
    if (originalParams[key] || originalParams[key] === false || emptyParams?.includes(key)) {
      if (typeof originalParams[key] === 'object' && !(originalParams[key] instanceof Array)) {
        // Si la propiedad es un objeto se llama recursivamente a esta funcion con esta propiedad y se asigna el resultado
        const cleanProp: object = cleanParams(originalParams[key]);
        if (Object.keys(cleanProp).length) {
          cleanProps[key] = cleanProp;
        }
      } else {
        // Si la propiedad no es un objeto se asigna directamente
        cleanProps[key] = originalParams[key];
      }
    }
  }
  return cleanProps;
}

export function deepMerge(target: any, source: any) {
  for (const key in source) {
    if (
      source[key] &&
      typeof source[key] === 'object' &&
      !Array.isArray(source[key])
    ) {
      if (!target[key] || typeof target[key] !== 'object') {
        target[key] = {};
      }
      deepMerge(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  }
  return target;
}

export function toogleModal(_id: string, _dismiss: boolean) {
  const globalModalShowPb = document.createElement('div');
  document.body.appendChild(globalModalShowPb);
  globalModalShowPb.setAttribute('data-bs-target', `${_id}`);
  if (!_dismiss) globalModalShowPb.setAttribute('data-bs-toggle', 'modal')
  else globalModalShowPb.setAttribute('data-bs-toggle', 'dismiss');
  globalModalShowPb.click();
  document.body.removeChild(globalModalShowPb);
}

export function toogleGenericModal(_id: string, _dismiss: boolean) {
  let modal = document.querySelector(_id) as HTMLButtonElement;
  modal.setAttribute('data-bs-backdrop', 'static');
  let openPb = document.createElement('button') as HTMLButtonElement;
  document.body.appendChild(openPb);
  openPb.setAttribute('data-bs-target', _id);
  
  if (!_dismiss) {
    openPb.setAttribute('data-bs-toggle', 'modal');
    
    openPb.click();
    document.body.removeChild(openPb);
  } else {
    setTimeout(() => {
      //to ensure right render while refreshing many times
      openPb.setAttribute('data-bs-dismiss', 'modal');
      openPb.click();
      document.body.removeChild(openPb);
    }, 500); // .5 segundos
  }
}

export function setExpiredToken() {
  /*-------inject an expired token----------*/
  setTimeout(() => {
    localStorage.setItem('auth', '{"accessToken":"eyJraWQiOiJ5ajMxTnNZSHZhMnVZa2xIZUhpSTRzOWFWaGk1OHdYcXFDTWF3VlpYbHQ4PSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiJlMjU1OTRhNC04MGUxLTcwZDAtOGU4OC0yMDdjMzI5OTA5MmYiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuZXUtd2VzdC0xLmFtYXpvbmF3cy5jb21cL2V1LXdlc3QtMV9hUElhUHg4ckIiLCJjbGllbnRfaWQiOiI0MmlpY292azRlNW5pZHYzNmQzaGI0dGcwciIsIm9yaWdpbl9qdGkiOiI3MjI5NjExZS0zN2MzLTQ5YTktYjRhYy0xMmMyOGNmNWRlNDkiLCJldmVudF9pZCI6ImI1ZWUwZTEwLTU0NWMtNDY5ZC1iY2U5LWQ1MTllZTM2NDY3OCIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE3NTE2MTAzMzgsImV4cCI6MTc1MzgwNzUwMiwiaWF0IjoxNzUzODAwMzAyLCJqdGkiOiI5OGU0NjNjYy02YmQ3LTRlNTUtOTk1Zi03MzcyYmNjZTQ5MmMiLCJ1c2VybmFtZSI6ImFkbWluIn0.TdMyogLKuR5IDh4cpnD8TioM2Ud7VuQzaVfS2NT1JYFYxDV6pXgK2vY6HBTujDGdR_MbFQBVyS4f2lxvrI22DGBd9nHLqU8ENh2Oi4ASoHto_9BTsMtlH-H5wPPlp9OexJULYP6-5iMj1g7W5hVMpg3Bu_WRx43jJio6pJ3K81JJmmhm5GwRCuZHUoi_KBvdbn6Zb5CPI0GVpTwt90rynii3SdABIstzj4f2SmcCIw-yEq7bFDVDL8tsZmMEEWp23yTsfDFV5-2EZz0YANZ0HVhCLPMpvvnD28bACeHND4vXJxA0PxY6IKD0DURe1YLW80gJt90Fkp1SYiaQiZAxLw","refreshToken":"eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.Z-ZiqNOwCPcm9ivpFCmnOhecizSOmzaYXVFyBi-YiX9re8bbRY0YvrVLfwF9qukyeTb_J9VI0XDymPzc2AGHbPvib7UMdr7FAArGdxGayaX7rT4J2SzLcPwCpU3-FwCLfQILLeZFNMrJ7mGod8dDzQuiqueIgkeN2G9WBPK7JLJfI5DqWQ-fP0WC7ovvTG43epLhvnV_rlknvNlBwsC1PQf5810-tUy9vt2XpL5L6bEFXVrFlcdWc_S792-I5vW0QJuhexDtWabfSU2t8R66ZgRptLW1_uoDg9T5U9cuxUSlRiTmFNQIw8TJXBrV9mMdLyiFtZU_3ohY8gqVI3ZkJQ.UMVK0xJbyIFWqXuY.DVIVhbZ_y8wMMvJs4d9rf5fJnneyTmFOungOLbI6EITk_Lwhh3zVkB1-ewLNe_FqFiHKyDj0R88yTqRRAtWWrHENNB2j_QSIApjJzbg68Qsz4EHtbsV9snZEbQbM-dK4i08pE6yFu561yLwqeudInUNwKGEY3KDJT4XzL-zoyXszgjYChRrtLH5H4CG5_QpSnU2uCPgd7X7UsSEK0tr90zxPML8dkYdXYpPxMTSnwDWf_bk68NSt019uPH6Vzkmyug2QQo_clXkd3fMmoktYF2cON89FWtJo5wJd-5yYZESHj-qxsKJV4j_gXpsoZveEU3qWaiKg14vToMhXc8e962E7jwcKRC2UFzs9Mp3Rcqk3ot8sLZcu6dHf47nE87MbVI3BPwfeHaGTR9-sKllpHIvs83b7yoC7ZN4yF7H8sTi_zZuxZ6d8pwL57nulHilZCE2iru494c3V65ZGa4X_f1AgyG_RMkG3Wzkwqg62v4MNNjYywfbi9DWc74IgVzmYtYXevl3u1LxkUATtbZobR2_tO_k9IIVudOC44XHAWNF10du3T_7b8go-TEKYGe9j9lEUUZ_0LxnhWe8CX7_bSXrmEQZ5D0KM9KHm5puM2HQgd4lAQZze_Lg68Fl7C3ezFIH-snpOFSw9VJvzI59XZklCgPlGDdpt_s3fWKyTtUVfog6h8psfQ5rUtITgMbPctbMRWBh7VCW73UJLne0TgA9ucC4gyxf_UfGr9jh7rU17pBdgtyOcayCmTR4OhTaYGDyFhWQa51hEu3mMrl8Y5UCwhblbPeU9_8ffVz5AXovwzNKqFMr9uCYu-vOsvPDrp65VMLGERY1MhtehoKo69sIRA-FkeQk3rG9KCUWrFm6lLaINYjce77JGDOw3HjRK5yXOdT2DD55Cm8nvBbBw7B6N0wAKOuo-pkBrZf0JRLQ0Jss1tW8FP4zIrs4JFgn59JLNA3zUsNhuvPfc0GDjfa3iftPoFEZPrxB2DGHgHo1HAPIpBXwpvQyad_OYgoJeiNW4chxR77WxLwSzud1ib_8odPHfm58KU7ZsmEu7HViBJxm30SVo86Ea_NGuvrdnrfi0MlSVYWeqVFWqdL6Kl1l8SCXibmVf2QGJ83EDzdBLrslVDiUXDI7tPHUfs7TcgVU4bED52BzK3_on5rW-garkSvmRi4EZTqfqT7J6X9L2OSVqglI2cImYlpUthOpvVkQITDBjfjrXz4ZgOgZL7BvhDP9rIJ3w5N-YrieA-ab5eRfDgNywzdWwZ_YA9kzT63Os.o9f5_fXXiNuToIWh79rngg"}')
  }, 10000); // .5 segundos
}


export function toNumber(data: any): number {
  return Number(data)
}

export function toBase64(fileInput: string, entityId: number): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const file = (document.querySelector('#' + fileInput + '-' + entityId) as HTMLInputElement).files?.[0];
    if (file) {
      reader.readAsDataURL(file as Blob);
      reader.onload = () => resolve(reader.result?.toString() ?? '');
      reader.onerror = reject;
    } else {
      resolve('');
    }
  });
}

export function toBase64PreventFromPadding(fileInput: string, entityId: number): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const file = (document.querySelector('#' + fileInput + '-' + entityId) as HTMLInputElement).files?.[0];
    if (file) {
      reader.readAsArrayBuffer(file as Blob);
      //reader.onload = () => resolve(PreventFromPadding(reader.result?.toString() ?? '') ?? '');
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer; // Note: not oReq.responseText
        if (arrayBuffer) {
          console.log(file.name);
          const ext = file.name.split('.')[1];
          const b64img = arrayBufferToBase64(arrayBuffer);
          console.log(b64img);
          //resolve('data:image/' + ext + ';base64,' + PreventFromPadding(b64img));
          resolve(b64img);
        }
      }
      reader.onerror = reject;
    } else {
      resolve('');
    }
  });
}

var blobURL;
var fileName;

function readFile(fileInput: string, entityId: number) {
  const file = (document.querySelector('#' + fileInput + '-' + entityId) as HTMLInputElement).files?.[0];
  const f = file;

  if (f) {
    if (/(jpe?g|png|gif|mp4)$/i.test(f.type)) {
      var r = new FileReader();
      r.onload = function (e) {
        var base64Img = e.target!.result;
        var binaryImg = convertDataURIToBinary(base64Img);
        var blob = new Blob([binaryImg], { type: f.type });
        blobURL = window.URL.createObjectURL(blob);
        fileName = f.name;
      }
      r.readAsDataURL(f);
    } else {
      //alert("Failed file type");
    }
  } else {
    //alert("Failed to load file");
  }
}

export function toBinary(fileInput: string, entityId: number): Promise<any> {
  return new Promise((resolve, reject) => {
    const file = (document.querySelector('#' + fileInput + '-' + entityId) as HTMLInputElement).files?.[0];
    const f = file;
    if (f) {
      if (/(jpe?g|png|gif|mp4)$/i.test(f.type)) {
        var r = new FileReader();
        r.onload = function (e) {
          var base64Img = e.target!.result;
          var binaryImg = convertDataURIToBinary(base64Img);
          var blob = new Blob([binaryImg], { type: f.type });
          blobURL = window.URL.createObjectURL(blob);
          fileName = f.name;
          resolve(blob)
        }
        r.readAsDataURL(f);
      } else {
        alert("Failed file type");
      }
    } else {
      alert("Failed to load file");
    }
  });
}

export function readChunkAsBinary(file: File, start: number, end: number): Promise<Uint8Array> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const fileChunk = file.slice(start, end);

    reader.onload = () => {
      // Convert the result to Uint8Array
      const arrayBuffer = reader.result as ArrayBuffer;
      const binaryData = new Uint8Array(arrayBuffer);
      resolve(binaryData);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsArrayBuffer(fileChunk); // Read the chunk as ArrayBuffer
  });
}

function convertDataURIToBinary(dataURI: any) {
  const BASE64_MARKER = ';base64,';
  let base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  let base64 = dataURI.substring(base64Index);
  let raw = window.atob(base64);
  return base64
}

export function videoFile(fileInput: string, entityId: number): Promise<File> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const file = (document.querySelector('#' + fileInput + '-' + entityId) as HTMLInputElement).files?.[0];
    if (file) {
      resolve(file)
      /*reader.readAsArrayBuffer(file as Blob);
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer; // Note: not oReq.responseText
        if (arrayBuffer) {
          console.log(file.name);
          const ext = file.name.split('.')[1];
          const b64img = arrayBufferToBase64(arrayBuffer);
          console.log(b64img);
          resolve(b64img);
        }
      }*/
      reader.onerror = reject;
    }
  });
}

export function arrayBufferToBase64(buffer: ArrayBuffer) {
  let binary = ''
  const bytes = new Uint8Array(buffer)
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary);
}

export function objectToBase64(object: any) {
  return btoa(JSON.stringify((object)));
}

export function PreventFromPadding(_base64: string): string {
  //_base64 += ('=').repeat((4 - _base64.length % 4) % 4);
  const splitBase64 = _base64.split(',');
  splitBase64.length > 1
    ? _base64 = splitBase64[1]
    : _base64 = splitBase64[0];
  return _base64
}

export function base64data(source: any) {
  let encodedSource = CryptoJS.enc.Base64.stringify(source);

  encodedSource = encodedSource.replace(/=+$/, '');

  encodedSource = encodedSource.replace(/\+/g, '-');
  encodedSource = encodedSource.replace(/\//g, '_');

  return encodedSource;
}

export function encodeToken(payload: any) {
  const header = {
    "alg": "HS256",
    "typ": "JWT"
  };

  const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  const encodedHeader = base64data(stringifiedHeader);

  const stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(payload));
  const encodedData = base64data(stringifiedData);

  const token = encodedHeader + "." + encodedData;
  return token
}

export function signToken(payload: any, key: string) {
  const secret = key;
  const token: any = encodeToken(payload);

  let signature: any = CryptoJS.HmacSHA256(token, secret);
  signature = base64data(signature);

  const signedToken = token + "." + signature;
  return signedToken;
}

export const backoffice_languages = [
  { name: 'ARABIC', value: 'ar'},
  { name: 'BULGARIAN', value: 'bg'},
  { name: 'GERMAN', value: 'de'},
  { name: 'GREEK', value: 'el'},
  { name: 'AUSTRALIAN', value: 'en-AU'},
  { name: 'ENGLISH', value: 'en-GB'},
  { name: 'SPANISH', value: 'es-ES'},
  { name: 'FRENCH', value: 'fr'},
  { name: 'HEBREW', value: 'he'},
  { name: 'HUNGARIAN', value: 'hu'},
  { name: 'ITALIAN', value: 'it'},
  { name: 'KOREAN', value: 'ko'},
  { name: 'LITHUANIAN', value: 'lt'},
  { name: 'MALAY', value: 'ms'},
  { name: 'DUTCH', value: 'nl'},
  { name: 'POLISH', value: 'pl'},
  { name: 'PORTUGUESE', value: 'pt'},
  { name: 'PORTUGUESE-BR', value: 'pt-BR'},
  { name: 'ROMANIAN', value: 'ro'},
  { name: 'RUSSIAN', value: 'ru'},
  { name: 'SLOVENIAN', value: 'sl'},
  { name: 'TURKISH', value: 'tr'},
  { name: 'THAI', value: 'th'},
  { name: 'CHINESE', value: 'zh'},
  { name: 'CHINESE_TRADITIONAL', value: 'zh-TW'},
  { name: 'VIETNAMESE', value: 'vi-VN'}
]

export const languages = [
  { name: 'SPANISH', value: 'es-ES' },
  { name: 'ENGLISH', value: 'en-GB' },
  { name: 'FRENCH', value: 'fr' },
  { name: 'ITALIAN', value: 'it' },
  { name: 'HEBREW', value: 'he' },

]

export const languages_invision = [
  { name: 'SPANISH', value: 'es-ES' },
  { name: 'ENGLISH', value: 'en-GB' },
  { name: 'FRENCH', value: 'fr' },
  { name: 'PORTUGUESE', value: 'pt' },
  { name: 'ITALIAN', value: 'it' },
  { name: 'GERMAN', value: 'de' },
  { name: 'THAI', value: 'th' },
  { name: 'POLISH', value: 'pl' },
  { name: 'HUNGARIAN', value: 'hu' },
  { name: 'ROMANIAN', value: 'ro' }
]

export const languages_360 = [
  { name: 'ENGLISH', value: 'en-GB' }
]

export const languages_mimesys = [
  { name: 'ARABIC', value: 'ar'},
  { name: 'AUSTRALIAN', value: 'en-AU'},
  { name: 'BULGARIAN', value: 'bg'},
  { name: 'BRETON', value: "br"},
  { name: 'GERMAN', value: 'de'},
  { name: 'ENGLISH', value: 'en-GB'},
  { name: 'SPANISH', value: 'es-ES'},
  { name: 'FRENCH', value: 'fr'},
  { name: 'HEBREW', value: 'he'},
  { name: 'ITALIAN', value: 'it' },
  { name: 'LITHUANIAN', value: 'lt'},
  { name: 'POLISH', value: 'pl'},
  { name: 'PORTUGUESE', value: 'pt'},
  { name: 'SLOVENIAN', value: 'sl'},
  { name: 'THAI', value: 'th'},
  { name: 'TURKISH', value: 'tr'},
  { name: 'CHINESE', value: 'zh'},
  { name: 'KOREAN', value: 'ko'},
  { name: 'VIETNAMESE', value: 'vi-VN'}
]
